import { FETCH_ERROR } from '@nord/tool.redux-api/es/actionTypes';

import { IReduxAction } from '../../types';

/**
 * Checks if the given Redux action is the result of a network-related fetch error.
 * That's the case when the action is of type FETCH_ERROR and does not carry a response status code.
 *
 * @param {IReduxAction} action - The Redux action object to be checked.
 * @returns {boolean} Returns true if the action is a network-related fetch error, otherwise false.
 */
export const isNetworkRelatedFetchError = (action: IReduxAction): boolean => {
  return (
    action.type === FETCH_ERROR &&
    typeof action.payload === 'object' &&
    !('status' in action.payload)
  );
};
